<template>
  <div class="text-gray-dark">
    <SectionTitle v-model="show">
      Featured in
    </SectionTitle>

    <FeaturedInCarousel v-if="show" class="featuredin-carousel" :articles="venue.featured_articles" :slides-to-show="2" />
  </div>
</template>

<script>
import FeaturedInCarousel from '~/components/shared/FeaturedInCarousel'
import SectionTitle from '~/components/venue/SectionTitle'

export default {
  components: { SectionTitle, FeaturedInCarousel },

  props: {
    venue: { type: Object, required: true },
  },

  data: () => {
    return {
      show: true,
    }
  },
}
</script>

<style scoped lang="scss">
@media (min-width: 912px) {
  .featuredin-carousel { max-width: 672px; }
}
:deep() {
  .slick-prev, .slick-next { top: 80px; }
}
</style>
